export const BuildInfo = {timestamp:1780088573000}
